import { Button } from 'components/atoms';
import { usePlayerProvider } from 'providers/PlayerProvider';
import { useStoreState } from 'providers/StoreStateContext';
import { useTranslation } from 'react-i18next';
import { PiPauseFill, PiPlayFill } from 'react-icons/pi';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface AudioPlayerProps {
  trackId: string;
  url?: string;
  disabled?: boolean;
}

const AudioPlayer = ({ trackId, url, disabled }: AudioPlayerProps) => {
  const { t } = useTranslation();
  const { playerTrackId, setPlayerTrackId } = useStoreState();
  const { isTrackPlaying, playTrack, pauseTrack, setIsTrackPlaying } =
    usePlayerProvider();

  const isCurrentTrack = !!trackId && playerTrackId === trackId;
  const isPlaying = isCurrentTrack && isTrackPlaying;
  const isDisabled = disabled || !trackId || url === '';

  const handleToggle = () => {
    if (isDisabled) {
      return;
    }

    if (isCurrentTrack) {
      if (isTrackPlaying) {
        pauseTrack();
      } else {
        playTrack();
      }
      return;
    }

    setIsTrackPlaying(true);
    setPlayerTrackId(trackId);
  };

  return (
    <Button
      type='button'
      onlyIcon
      isClear
      variant={BUTTON_VARIANT.submit}
      disabled={isDisabled}
      onClick={handleToggle}>
      <Button.Description
        description={isPlaying ? t('button.pause') : t('button.play')}
      />
      <Button.Icon icon={isPlaying ? <PiPauseFill /> : <PiPlayFill />} />
    </Button>
  );
};

export default AudioPlayer;
